import Vue from 'vue';

import CommonConfirm from '@/components/common/CommonConfirm';
import CommonCrud from '@/components/common/CommonCrud';
import CommonScore from '@/components/common/CommonScore';
import CommonUpload from '@/components/common/CommonUpload';
import CnyInput from '@/components/common/CNYInput';
import SelectTree from '@/components/common/SelectTree';
import CommonEchars from '@/components/common/CommonEchars';
import ApprovalDialog from '@/components/common/ApprovalDialog';
import CommonEditor from '@/components/common/CommonEditor';
import CommonTooltip from '@/components/common/CommonTooltip';

Vue.component("common-confirm", CommonConfirm);
Vue.component("common-crud", CommonCrud);
Vue.component("common-score", CommonScore);
Vue.component("common-upload", CommonUpload);
Vue.component("cny-input", CnyInput);
Vue.component("select-tree", SelectTree);
Vue.component("common-echars", CommonEchars);
Vue.component("approval-dialog", ApprovalDialog);
Vue.component("common-editor", CommonEditor);
Vue.component("common-tooltip", CommonTooltip);




// WEBPACK FOOTER //
// ./src/util/globalComponents.js